import { render } from "./JoindreFichiers.vue?vue&type=template&id=88c3ff56"
import script from "./JoindreFichiers.vue?vue&type=script&lang=js"
export * from "./JoindreFichiers.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__